module.exports = __webpack_public_path__ + "img/NotAvatar.446ac29d.png";